import { useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { blogPages } from "@/blog/blogPages";
import { getBlogSummary } from "@/blog/blogIndex";
import { trackContentPageView } from "@/lib/analytics";

function BlogNotFound() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-stem-cream">
      <div className="text-center px-4">
        <div className="w-20 h-20 rounded-full bg-stem-sand flex items-center justify-center mx-auto mb-6">
          <i className="ri-emotion-sad-line text-stem-gray text-3xl" />
        </div>
        <h1 className="text-2xl md:text-3xl font-bold text-stem-dark mb-3">
          Story Not Found
        </h1>
        <p className="text-stem-gray mb-6">
          Hmm, I could not find that blog post. It might have been moved or
          deleted.
        </p>
        <button
          onClick={() => navigate("/blog")}
          className="btn-dark text-sm whitespace-nowrap"
        >
          <i className="ri-home-line" />
          Back to Stories
        </button>
      </div>
    </div>
  );
}

export default function BlogPage() {
  const { id } = useParams<{ id: string }>();
  const { pathname, search, hash } = useLocation();
  const BlogPostPage = id ? blogPages[id] : undefined;
  const post = getBlogSummary(id);

  useEffect(() => {
    if (!post) return;

    window.requestAnimationFrame(() => {
      void trackContentPageView({
        path: `${pathname}${search}${hash}`,
        contentType: "blog_post",
        contentId: post.id,
        contentTitle: post.title,
        contentCategory: post.category,
      });
    });
  }, [hash, pathname, post, search]);

  if (!BlogPostPage) {
    return <BlogNotFound />;
  }

  return (
    <div className="min-h-screen bg-stem-cream">
      <Navbar />
      <main>
        <BlogPostPage />
      </main>
      <Footer />
    </div>
  );
}
